import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'antd';

import CardContent from './CardContent';

const { Meta } = Card;

const propTypes = {
  title: PropTypes.any,
  description: PropTypes.any,
  loading: PropTypes.bool,
  data: PropTypes.object,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      render: PropTypes.func,
    }).isRequired,
  ).isRequired,
};
const defaultProps = {
  title: null,
  description: null,
  loading: false,
  data: {},
};

const InfoCard = ({ title, description, data, fields, loading }) => (
  <Card loading={loading}>
    <Meta title={title} description={description} />
    <CardContent
      data={data}
      fields={fields}
      withHeader={!!(title || description)}
    />
  </Card>
);
InfoCard.propTypes = propTypes;
InfoCard.defaultProps = defaultProps;

export default InfoCard;
